"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Node = /** @class */ (function () {
    function Node(_a) {
        var id = _a.id;
        this.id = null;
        this.parent = null;
        this.children = [];
        this.id = id;
    }
    Node.prototype.appendChild = function (child) {
        child.parent = this;
        this.children.push(child);
    };
    Node.prototype.removeChild = function (child) {
        var index = this.children.indexOf(child);
        child.parent = null;
        this.children.splice(index, 1);
    };
    Node.prototype.insertBefore = function (child, beforeChild) {
        var index = this.children.indexOf(beforeChild);
        child.parent = this;
        this.children.splice(index, 0, child);
    };
    Node.prototype.render = function () {
        this.children.forEach(function (child) { return child.render(); });
    };
    Node.prototype.destroy = function () {
        this.children.forEach(function (child) {
            child.destroy();
        });
        if (this.parent) {
            this.parent = null;
        }
    };
    return Node;
}());
exports.default = Node;
